export const isString = (value: unknown): value is string => typeof value === 'string';

export const isNumber = (value: unknown): value is number => typeof value === 'number';

export const isBoolean = (value: unknown): value is boolean => typeof value === 'boolean';

export const isFunction = (value: unknown): value is (...args: any[]) => any => typeof value === 'function';

// lodash isObject: true for objects, arrays, AND functions; false for null and primitives
export const isObject = (value: unknown): value is object => value != null && (typeof value === 'object' || typeof value === 'function');

// lodash isObjectLike: non-null and typeof 'object' (excludes functions)
export const isObjectLike = (value: unknown): boolean => typeof value === 'object' && value !== null;

export const isRegExp = (value: unknown): value is RegExp => value instanceof RegExp;

// lodash isArrayLike: not null, not a function, has a valid non-negative length
export const isArrayLike = (value: any): boolean =>
  value != null
  && typeof value !== 'function'
  && typeof value.length === 'number'
  && value.length >= 0
  && value.length <= Number.MAX_SAFE_INTEGER;

/**
 * lodash isEmpty: true for null/undefined and non-collection primitives (numbers, booleans);
 * for strings/arrays/typed-arrays -> length is 0; for Map/Set -> size is 0; for objects -> no own enumerable keys.
 */
export const isEmpty = (value: unknown): boolean => {
  if (value == null) return true;
  if (Array.isArray(value) || typeof value === 'string') return value.length === 0;
  if (typeof value !== 'object') return true;
  if (value instanceof Map || value instanceof Set) return value.size === 0;
  if (ArrayBuffer.isView(value) || typeof (value as { splice?: unknown }).splice === 'function') {
    return (value as { length: number }).length === 0;
  }
  return Object.keys(value).length === 0;
};

export const toFiniteNumber = (value?: number | string | null): number | null => {
  if (value === null || value === undefined || value === '') return null;

  const numberValue = Number(value);

  return Number.isFinite(numberValue) ? numberValue : null;
};
